import { notify, notifyAll } from "./storageSubscriptions";
import { StorageType } from "./types";

// This wrapper feels **bad**. We should be providing a safe alternative for users who have local/session
// storage disabled or unavailable, but this also masks real errors that might occur when interacting with storage.
// We should detect full usage of storage up front and fallback to an in-memory storage solution if necessary.
// Keeping this for now to avoid breaking changes, but we should revisit this in the future.
export function makeSafeStorageWrapper(type: StorageType, storage: Storage, warn: boolean = true): Storage {
  return {
    setItem(key: string, value: string) {
      try {
        storage.setItem(key, value);
        notify(type, key);
      } catch (e) {
        if (warn) {
          // eslint-disable-next-line no-console
          return console.warn(`unable to set ${type} storage key ${key} to value ${value}`);
        }

        throw e;
      }
    },

    getItem(key: string) {
      try {
        return storage.getItem(key);
      } catch (e) {
        if (warn) {
          // eslint-disable-next-line no-console
          console.warn(`unable to get ${type} storage key ${key}`);
          return null;
        }

        throw e;
      }
    },

    removeItem(key: string) {
      try {
        storage.removeItem(key);
        notify(type, key);
        return;
      } catch (e) {
        if (warn) {
          // eslint-disable-next-line no-console
          console.warn(`unable to remove ${type} storage key ${key}`);
          return;
        }

        throw e;
      }
    },

    get length() {
      try {
        return storage.length;
      } catch (e) {
        if (warn) {
          // eslint-disable-next-line no-console
          console.warn(`unable to get ${type} storage length`);
          return 0;
        }
        throw e;
      }
    },

    clear() {
      try {
        storage.clear();
        notifyAll(type);
      } catch (e) {
        if (warn) {
          // eslint-disable-next-line no-console
          console.warn(`unable to clear ${type} storage`);
          return;
        }
        throw e;
      }
    },

    key(index: number) {
      try {
        return storage.key(index);
      } catch (e) {
        if (warn) {
          // eslint-disable-next-line no-console
          console.warn(`unable to get ${type} storage key at index ${index}`);
          return null;
        }
        throw e;
      }
    },
  };
}
